import { create } from "zustand";

interface TaskDetailState {
  close(): void;
  setTaskId(id: string): void;
  taskId?: string;
}


export const useTaskDetailStore = create<TaskDetailState>((set) => ({
  taskId: undefined,
  setTaskId: (id) => set({ taskId: id }),
  close: () => set({ taskId: undefined }),
}));
